import {
  HubspotDealRefSchema,
  HubspotStageNormalizedSchema,
  ProfileAttachStatusSchema,
  RegistrationStatusSchema,
  UserRefSchema,
} from "@redotech/redo-model/recover/registration-dashboard";
import * as z from "zod/v4";

/**
 * Single-team view for the merchant-detail Provisioning tab. Returns
 * the full brand + campaign rows (including submitted payload + last
 * rejection reason) plus HubSpot context + attach status.
 */
export const getRecoverRegistrationDetail = {
  name: "getRecoverRegistrationDetail" as const,
  input: z.object({ teamId: z.string() }),
  output: z.object({
    teamId: z.string(),
    teamName: z.string(),
    phoneNumber: z.string().nullable(),
    submittedAt: z.date().nullable(),
    submittedByUser: UserRefSchema.nullable(),
    reviewedDoneAt: z.date().nullable(),
    reviewedDoneByUser: UserRefSchema.nullable(),
    hubspot: HubspotDealRefSchema.nullable(),
    brand: z
      .object({
        status: RegistrationStatusSchema,
        telnyxBrandId: z.string().nullable(),
        tcrBrandId: z.string().nullable(),
        lastRejectionReason: z.unknown().nullable(),
        submittedPayload: z.unknown(),
        statusSetAt: z.date(),
      })
      .nullable(),
    campaign: z
      .object({
        status: RegistrationStatusSchema,
        telnyxCampaignId: z.string().nullable(),
        tcrCampaignId: z.string().nullable(),
        lastRejectionReason: z.unknown().nullable(),
        submittedPayload: z.unknown(),
        statusSetAt: z.date(),
      })
      .nullable(),
    profileAttachStatus: ProfileAttachStatusSchema,
    messagingProfileId: z.string().nullable(),
    telnyxPhoneNumberId: z.string().nullable(),
    hubspotStage: HubspotStageNormalizedSchema.nullable(),
  }),
};
